// Палитрата е отделна от режима: всяка тема има светъл и тъмен вариант.
export const PALETTES = { green: 'Зелена', blue: 'Синя', graphite: 'Графитена', warm: 'Топла' };
const colors = {
  green: ['#116b57', '#0b5544', '#e9f5ee', '#173a34', '#31544a', '#74d9b3', '#58c69e', '#214239'],
  blue: ['#285fba', '#204d98', '#e9f0fc', '#1b304f', '#354d70', '#91b8ff', '#75a4f5', '#243e61'],
  graphite: ['#4d5667', '#3c4453', '#eceef2', '#292d35', '#454b56', '#c4cbd8', '#a9b3c5', '#373e49'],
  warm: ['#8b502e', '#703e22', '#f5e9db', '#45372c', '#65503e', '#e6b18a', '#d29b72', '#493627'],
};
export function ensurePaletteStyle() {
  if (document.getElementById('palette-css')) return;
  const style = document.createElement('style'); style.id = 'palette-css';
  style.textContent = Object.entries(colors).map(([id, c]) =>
    ':root[data-palette="' + id + '"]{--accent:' + c[0] + ';--accent-hover:' + c[1] + ';--accent-soft:' + c[2] + ';--nav-bg:' + c[3] + ';--nav-active:' + c[4] + ';}' +
    ':root[data-palette="' + id + '"][data-theme="dark"]{--accent:' + c[5] + ';--accent-hover:' + c[6] + ';--accent-soft:' + c[7] + ';}'
  ).join('\n');
  (document.head || document.documentElement).appendChild(style);
}
